export default class Simplecast {
    constructor(elem, APP) {
        this.elem = elem
        this.simplecastTriggers = this.elem.querySelectorAll('.simplecast-trigger');
        this.player = document.querySelector('.simplecast-embed')
        this.body = document.querySelector('body')
        this.closePlayer = document.querySelector('.close-player')
    }

    openPlayer() {
        this.simplecastTriggers.forEach((item) => {
            item.addEventListener("click", (e) => {
                e.preventDefault()
                this.body.classList.add('fixed-nav')
                this.player.classList.toggle('active')
                // console.log('trigger episode')
                let episodeID = item.getAttribute('data-episode');
                console.log(episodeID)
                this.player.innerHTML = `<iframe height="52px" width="100%" frameborder="no" scrolling="no" seamless src="https://player.simplecast.com/${episodeID}?dark=true&color=152447"></iframe>`;
            })
        })
        
        
        this.closePlayer.addEventListener('click', () => {
            this.player.innerHTML = '';
            this.closePlayer.style.display = 'none';
         })
    }

    init() {
        this.openPlayer()
    }
}